import { useState } from 'react';

type TreeNode = {
  name: string;
  path: string;
  children?: TreeNode[];
};

const initialTree: TreeNode = {
  name: 'main',
  path: 'main',
  children: [
    {
      name: 'buy',
      path: 'buy',
      children: [
        { name: 'tools', path: 'buy/tools' },
        { name: 'resources', path: 'buy/resources' },
      ],
    },
    {
      name: 'sell',
      path: 'sell',
      children: [
        { name: 'tools', path: 'sell/tools' },
        { name: 'resources', path: 'sell/resources' },
      ],
    },
    {
      name: 'sell-buy',
      path: 'sell-buy',
      children: [
        { name: 'tools', path: 'sell-buy/tools' },
        { name: 'resources', path: 'sell-buy/resources' },
      ],
    },
  ],
};

function useNavigator() {
  const [currentNode, setCurrentNode] = useState<TreeNode>(initialTree);

  const onPageChange = (path: string) => {
    const pathParts = path.split('/');
    let current = initialTree;

    for (const part of pathParts) {
      const child = current.children?.find((c) => c.name === part);
      if (child) {
        current = child;
      } else {
        // If path not found, reset to the main page
        current = initialTree;
        break;
      }
    }

    setCurrentNode(current);
  };

  const getParentOfCurrentNode = () => {
    const pathParts = currentNode.path.split('/');
    if (pathParts.length === 1) {
        return 'main'
    }
    return pathParts[0];
  }

  const goBack = () => {
    const pathParts = currentNode.path.split('/');
    if (pathParts.length > 1) {
      pathParts.pop(); // Remove the last part (current subpage or nested subpage)
      const newPath = pathParts.join('/');
      onPageChange(newPath);
    } else {
      onPageChange('main');
    }
  };

  const resetState = () => {
    setCurrentNode(initialTree);
  };

  return { currentNode, onPageChange, goBack, getParentOfCurrentNode, resetState };
}

export default useNavigator;
